<app-card>
  <form [formGroup]="ruleForm" (submit)="onSubmit()">
    <div class="grid form-grid">
      <div class="form-header">
        <app-input-wrapper [control]="ruleForm.controls['name']">
          <input
            formControlName="name"
            [placeholder]="'rules.detail.namePlaceholder' | translate"
            type="text"
          />
        </app-input-wrapper>
      </div>
      <div class="condition">
        <h2>{{ "rules.condition" | translate }}</h2>
        <div formArrayName="conditions">
          <div
            *ngFor="let condition of conditions.controls; let i = index"
            [formGroupName]="i"
          >
            <fieldset class="card">
              <legend>
                <app-text-with-icon
                  [name]="getConditionType(condition.get('type')?.value).icon"
                >
                  {{
                    getConditionType(condition.get("type")?.value).label
                      | translate
                  }}
                </app-text-with-icon>
              </legend>
              <button
                type="button"
                class="button icon-button absolute-top"
                (click)="removeCondition(i)"
              >
                <app-icon name="ic_close" />
              </button>

              @for (key of condition | formKeys; track keyTrackBy(key)) {
                @if (
                  key !== "type" &&
                  fieldConfigs.hasOwnProperty(key) &&
                  condition.get(key)!.enabled
                ) {
                  <app-input-wrapper
                    [label]="fieldConfigs[key].label | translate"
                    [unit]="fieldConfigs[key].unit"
                    [control]="condition.get(key)!"
                    [isSelect]="isSelectField(fieldConfigs[key].type)"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        dynamicFieldTemplate;
                        context: {
                          type: fieldConfigs[key].type,
                          key: key,
                          fieldConfigs: fieldConfigs,
                          parentGroup: condition,
                        }
                      "
                    >
                    </ng-container>
                  </app-input-wrapper>
                }
              }
            </fieldset>
          </div>
        </div>

        <h4>{{ "rules.detail.addCondition" | translate }}</h4>
        <div class="flex">
          @for (type of conditionTypes; track type.label) {
            @if (
              type.value !== FormConditionType.clockTime ||
              canAddClockTime(conditions)
            ) {
              <button
                type="button"
                class="button icon-button outlined-button"
                (click)="addCondition(type.value)"
                [title]="type.label | translate"
              >
                <app-icon [name]="type.value | icons" />
              </button>
            }
          }
        </div>
      </div>
      <div class="or-condition">
        <h2>{{ "rules.orCondition" | translate }}</h2>
        <div formArrayName="orConditions">
          <div
            *ngFor="let condition of orConditions.controls; let i = index"
            [formGroupName]="i"
          >
            <fieldset class="card">
              <legend>
                <app-text-with-icon
                  [name]="getConditionType(condition.get('type')?.value).icon"
                >
                  {{
                    getConditionType(condition.get("type")?.value).label
                      | translate
                  }}
                </app-text-with-icon>
              </legend>
              <button
                type="button"
                class="button icon-button absolute-top"
                (click)="removeOrCondition(i)"
              >
                <app-icon name="ic_close" />
              </button>

              @for (key of condition | formKeys; track keyTrackBy(key)) {
                @if (
                  key !== "type" &&
                  fieldConfigs.hasOwnProperty(key) &&
                  condition.get(key)!.enabled
                ) {
                  <app-input-wrapper
                    [label]="fieldConfigs[key].label | translate"
                    [unit]="fieldConfigs[key].unit"
                    [control]="condition.get(key)!"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        dynamicFieldTemplate;
                        context: {
                          type: fieldConfigs[key].type,
                          key: key,
                          fieldConfigs: fieldConfigs,
                          parentGroup: condition,
                        }
                      "
                    >
                    </ng-container>
                  </app-input-wrapper>
                }
              }
            </fieldset>
          </div>
        </div>

        <h4>{{ "rules.detail.addCondition" | translate }}</h4>
        <div class="flex">
          @for (type of conditionTypes; track type.label) {
            @if (
              type.value !== FormConditionType.clockTime ||
              canAddClockTime(orConditions)
            ) {
              <button
                type="button"
                class="button icon-button outlined-button"
                (click)="addOrCondition(type.value)"
                [title]="type.label | translate"
              >
                <app-icon [name]="type.value | icons" />
              </button>
            }
          }
        </div>
      </div>
      <div class="action">
        <h2>{{ "rules.action" | translate }}</h2>
        <div formArrayName="actions">
          <div
            *ngFor="let action of actions.controls; let i = index"
            [formGroupName]="i"
          >
            <fieldset class="card">
              <legend>
                @if (action.get("target")?.value === "device") {
                  <app-text-with-icon name="ic_ventile">
                    {{ "rules.detail.ventile" | translate }}
                  </app-text-with-icon>
                } @else {
                  <app-text-with-icon name="ic_organisation">
                    {{ "rules.detail.deviceGroup" | translate }}
                  </app-text-with-icon>
                }
              </legend>
              <button
                type="button"
                class="button icon-button absolute-top"
                (click)="removeAction(i)"
              >
                <app-icon name="ic_close" />
              </button>

              @for (key of action | formKeys; track keyTrackBy(key)) {
                @if (
                  key !== "type" &&
                  fieldConfigs.hasOwnProperty(key) &&
                  action.get(key)!.enabled
                ) {
                  <app-input-wrapper
                    [label]="fieldConfigs[key].label | translate"
                    [unit]="fieldConfigs[key].unit"
                    [control]="action.get(key)!"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        dynamicFieldTemplate;
                        context: {
                          type: fieldConfigs[key].type,
                          key: key,
                          fieldConfigs: fieldConfigs,
                          parentGroup: action,
                        }
                      "
                    >
                    </ng-container>
                  </app-input-wrapper>
                }
              }
            </fieldset>
          </div>
        </div>
        <div class="flex wrap">
          <button
            type="button"
            class="button icon-button outlined-button"
            (click)="addAction('device')"
          >
            <app-icon name="ic_plus" />
            {{ "rules.detail.addActionDevice" | translate }}
          </button>
          <button
            type="button"
            class="button icon-button outlined-button"
            (click)="addAction('deviceGroup')"
          >
            <app-icon name="ic_plus" />
            {{ "rules.detail.addActionDeviceGroup" | translate }}
          </button>
        </div>
      </div>
    </div>

    <aside class="aside">
      <h2>{{ "rules.checklist.title" | translate }}</h2>
      <ul class="list check">
        <li [class.checked]="ruleForm.get('name')?.errors === null">
          {{ "rules.checklist.name" | translate }}
        </li>
        <li [class.checked]="ruleForm.get('conditions')?.errors === null">
          {{ "rules.checklist.condition" | translate }}
        </li>
        <li [class.checked]="ruleForm.get('actions')?.errors === null">
          {{ "rules.checklist.action" | translate }}
        </li>
        <li [class.checked]="ruleForm.valid">
          {{ "rules.checklist.allFields" | translate }}
        </li>
      </ul>

      <div class="flex">
        <button type="button" class="button" (click)="onCancel()">
          {{ "default.cancel" | translate }}
        </button>
        <button class="button primary-button">
          {{ "default.save" | translate }}
        </button>
      </div>
    </aside>
  </form>
</app-card>

<ng-template
  #dynamicFieldTemplate
  let-type="type"
  let-key="key"
  let-fieldConfigs="fieldConfigs"
  let-parentGroup="parentGroup"
>
  <ng-container [formGroup]="parentGroup">
    @switch (type) {
      @case ("select") {
        <select [formControlName]="key">
          <option hidden disabled [value]="null">
            {{ fieldConfigs[key].placeholder | translate }}
          </option>
          @for (opt of fieldConfigs[key].options; track opt.value) {
            <option [value]="opt.value">{{ opt.label | translate }}</option>
          }
        </select>
      }
      @case ("selectAsync") {
        <select [formControlName]="key">
          <option hidden disabled [value]="null">
            {{ fieldConfigs[key].placeholder | translate }}
          </option>
          @for (opt of getAsyncOptions(key) | async; track opt.value) {
            <option [value]="opt.value">{{ opt.label | translate }}</option>
          }
        </select>
      }
      @case ("multiSelect") {
        <div class="flex wrap" [formGroupName]="key">
          @for (opt of fieldConfigs[key].options; track opt.value) {
            <span>
              <input
                class="multiselect"
                type="checkbox"
                [id]="opt.value"
                [formControlName]="opt.value"
              />
              <label [for]="opt.value">{{ opt.label | translate }}</label>
            </span>
          }
        </div>
      }
      @case ("number") {
        <input
          type="number"
          min="0"
          step="5"
          [formControlName]="key"
          [placeholder]="fieldConfigs[key].placeholder | translate"
        />
      }
      @case ("time") {
        <input
          type="time"
          [formControlName]="key"
          [placeholder]="fieldConfigs[key].placeholder | translate"
        />
      }
      @case ("percent") {
        <input
          type="number"
          min="0"
          max="100"
          step="5"
          [formControlName]="key"
          [placeholder]="fieldConfigs[key].placeholder | translate"
        />
      }
      @default {
        <input
          type="text"
          [formControlName]="key"
          [placeholder]="fieldConfigs[key].placeholder | translate"
        />
      }
    }
  </ng-container>
</ng-template>
